<template>
  <div class="page-content">
    <h1>{{ $t('v.placements.title') }}</h1>
        <v-section top-indent class="placements__sections">
          <v-notification-card :icon="'/i_notice.svg'" content-right-indent class="placements__sections-item">
            <p v-html="$t('v.placements.aboutWorstPlacements1')" />
            <p>{{ $t('v.placements.aboutWorstPlacements2') }}</p>
          </v-notification-card>

          <v-placements-autodisable class="placements-autodisable" />

        </v-section>

    <h2 class="conversion-date-title">Дата старта конверсии: {{ startDateConversion }}</h2>

    <v-type-placements-table
      :table-type="worstPlacementsType"
      ref="worstPlacementsTable"
      selection-column
      damage-column
      classification-column
      @selection-change="worstPlacementsSelection = $event"
    >
      <template #secondRowToolsLeft>
        <v-button
          theme="danger"
          :disabled="!canChangeBlacklistPlacements"
          @click="$refs.worstPlacementsSmartDialogBlacklist.open()"
        >{{ $t('v.placements.buttonAddToBlackList') }}</v-button>

        <v-button
          theme="info"
          :disabled="!canChangeWhitelistPlacements"
          @click="$refs.worstPlacementsSmartDialogWhitelist.open()"
        >{{ $t('v.placements.buttonAddToWhiteList') }}</v-button>
      </template>
    </v-type-placements-table>

    <v-section top-indent>
      <v-notification-card
        :icon="'/i_notice.svg'"
        content-right-indent
      >{{ $t('v.placements.aboutDisputedPlacements') }}</v-notification-card>
    </v-section>

    <v-type-placements-table
      :table-type="disputedPlacementsType"
      ref="disputedPlacementsTable"
      selection-column
      classification-column
      @selection-change="disputedPlacementsSelection = $event"
    >
      <template #secondRowToolsLeft>
        <v-button
          theme="danger"
          :disabled="!canChangeBlacklistPlacements"
          @click="$refs.disputableFirstBanConfirmationDialog.open()"
        >{{ $t('v.placements.buttonAddToBlackList') }}</v-button>

        <v-button
          theme="info"
          :disabled="!canChangeWhitelistPlacements"
          @click="addPlacementsToList(disputedPlacementsType, changeWhiteListType, disputedPlacementsSelection)"
        >{{ $t('v.placements.buttonAddToWhiteList') }}</v-button>
      </template>
    </v-type-placements-table>

    <v-section top-indent>
      <v-notification-card
        :icon="'/i_notice.svg'"
        content-right-indent
      >{{ $t('v.placements.aboutBestPlacements') }}</v-notification-card>
    </v-section>

    <v-type-placements-table
      :table-type="bestPlacementsType"
      ref="bestPlacementsTable"
      selection-column
      @selection-change="bestPlacementsSelection = $event"
    >
      <template #secondRowToolsLeft>
        <v-button
          theme="info"
          :disabled="!canChangeWhitelistPlacements"
          @click="$refs.bestPlacementsSmartDialogWhitelist.open()"
        >{{ $t('v.placements.buttonAddToWhiteList') }}</v-button>
      </template>
    </v-type-placements-table>

    <!-- dialogs -->
    <v-first-ban-confirmation-dialog
      ref="worstPlacementsSmartDialogBlacklist"
      v-if="canChangeBlacklistPlacements"
    >
      <template #default="{ step, resetStep }">
        <v-smart-confirmation-dialog
          :visible="step === 2"
          :title="$t('c.dialog.titleAddToBlackList')"
          :message="$t('c.dialog.messageAddToBlackList')"
          :options="radioOptions(worstPlacementsTotalCount, worstPlacementsSelection, worstPlacementsLimitForPage)"
          @confirm="addPlacementsToList(worstPlacementsType, changeBlackListType, worstPlacementsSelection, $event)"
          @close="resetStep()"
        />
      </template>
    </v-first-ban-confirmation-dialog>

    <v-first-ban-confirmation-dialog
      ref="disputableFirstBanConfirmationDialog"
      v-if="canChangeBlacklistPlacements"
    >
      <template #default="{ step, resetStep }">
        <v-confirmation-dialog
          :visible="step === 2"
          :title="$t('c.dialog.titleAddToBlackList')"
          :message="$t('c.dialog.messageAddToBlackList')"
          @confirm="addPlacementsToList(disputedPlacementsType, changeBlackListType, disputedPlacementsSelection)"
          @close="resetStep()"
        />
      </template>
    </v-first-ban-confirmation-dialog>

    <v-smart-confirmation-dialog
      v-if="canChangeWhitelistPlacements"
      ref="worstPlacementsSmartDialogWhitelist"
      :title="$t('c.dialog.titleAddToWhiteList')"
      :message="$t('c.dialog.messageAddToWhiteList')"
      :options="radioOptions(worstPlacementsTotalCount, worstPlacementsSelection, worstPlacementsLimitForPage)"
      @confirm="addPlacementsToList(worstPlacementsType, changeWhiteListType, worstPlacementsSelection, $event)"
    />

    <v-smart-confirmation-dialog
      v-if="canChangeWhitelistPlacements"
      ref="bestPlacementsSmartDialogWhitelist"
      :title="$t('c.dialog.titleAddToWhiteList')"
      :message="$t('c.dialog.messageAddToWhiteList')"
      :options="radioOptions(bestPlacementsTotalCount, bestPlacementsSelection, bestPlacementsLimitForPage)"
      @confirm="addPlacementsToList(bestPlacementsType, changeWhiteListType, bestPlacementsSelection, $event)"
    />
  </div>
</template>

<script>
import VTypePlacementsTable from '@/components/VTypePlacementsTable.vue'
import VFirstBanConfirmationDialog from '@/components/common/VFirstBanConfirmationDialog.vue'
import VConfirmationDialog from '@/components/common/VConfirmationDialog.vue'
import VSmartConfirmationDialog from '@/components/common/VSmartConfirmationDialog.vue'
import VNotificationCard from '@/components/common/VNotificationCard.vue'
import VSection from '@/components/common/VSection.vue'
import * as types from '@/store/types'
import * as authorities from '@/utils/authorities'
import storeUtils from '@/mixins/storeUtils'
import { getDuringOrCustomDateRange } from '@/utils/common'
import VPlacementsAutodisable from '@/components/Placements/VPlacementsAutodisable.vue'

export default {
  name: 'Placements',

  components: {
    VPlacementsAutodisable,
    VTypePlacementsTable,
    VFirstBanConfirmationDialog,
    VConfirmationDialog,
    VSmartConfirmationDialog,
    VNotificationCard,
    VSection
  },

  mixins: [storeUtils],

  data() {
    return {
      worstPlacementsType: types.WORST_PLACEMENTS,
      worstPlacementsSelection: [],
      disputedPlacementsType: types.DISPUTED_PLACEMENTS,
      disputedPlacementsSelection: [],
      bestPlacementsType: types.BEST_PLACEMENTS,
      bestPlacementsSelection: [],
      changeBlackListType: types.CHANGE_BLACKLIST_PLACEMENTS,
      changeWhiteListType: types.CHANGE_WHITELIST_PLACEMENTS
    }
  },

  computed: {
    startDateConversion() {
      const { conversionsSyncDate } = this.$store.state[
        types.GENERAL_CONFIGURATION
      ]
      return conversionsSyncDate
        ? conversionsSyncDate.split('-').reverse().join('-')
        : ''
    },

    dateRangeOptions() {
      return this.$store.getters.dateRangeArray(this.$i18n)
    },
    canChangeWhitelistPlacements() {
      return this.$store.getters.hasAuthorities(
        authorities.CHANGE_WHITELIST_PLACEMENTS
      )
    },
    canChangeBlacklistPlacements() {
      return this.$store.getters.hasAuthorities(
        authorities.CHANGE_BLACKLIST_PLACEMENTS
      )
    },
    worstPlacementsTotalCount() {
      return this.$store.state[this.worstPlacementsType].params.count
    },
    worstPlacementsLimitForPage() {
      return this.$store.state[this.worstPlacementsType].params.limit
    },

    bestPlacementsTotalCount() {
      return this.$store.state[this.bestPlacementsType].params.count
    },
    bestPlacementsLimitForPage() {
      return this.$store.state[this.bestPlacementsType].params.limit
    }
  },

  created() {
    this.$store.dispatch(types.GET_ACCOUNT_SETTINGS)
  },

  methods: {
    radioOptions(total, selection, pageLimit) {
      const count = selection.length

      if (count !== pageLimit) return []

      return [
        this.$tc('c.dialog.optionAddSelectedPlacements', count),
        this.$tc('c.dialog.optionAddAllPlacements', total)
      ]
    },

    fetchPlacementsByType(name) {
      const { loading } = this.$store.state[name]
      if (loading) this.$store.dispatch(types.FETCH_PLACEMENTS_BY_TYPE, { name })
    },

    addPlacementsToList(name, actionType, selection, selectedOption = null) {
      let action = 'ADD'
      if (actionType === this.changeBlackListType) {
        if (name === this.disputedPlacementsType) action = 'ADD_DISPUTED'
        if (name === this.worstPlacementsType) action = 'ADD_WORST'
      }
      const ids = selection.map(item => item.id)
      const { dateRange, customDateRange } = this.$store.state[name].params
      const during = getDuringOrCustomDateRange(dateRange, customDateRange)

      if (selectedOption === 1) {
        // Add all items in table to White / Black list
        const actionTypeForAll = actionType === this.changeBlackListType
          ? types.ADD_ALL_PLACEMENTS_TO_BLACKLIST
          : types.ADD_ALL_PLACEMENTS_TO_WHITELIST
        this.$store.dispatch(actionTypeForAll, { name, during }).then(() => {
          this.fetchPlacementsByType(name)
          if (actionType === this.changeWhiteListType) this.fetchPlacementsByType(this.disputedPlacementsType)
        })
      } else if (ids.length) {
        // Add custom items to White / Black list

        this.$store.dispatch(actionType, { name, ids, action }).then(() => {
          this.fetchPlacementsByType(name)
          if (actionType === this.changeWhiteListType) this.fetchPlacementsByType(this.disputedPlacementsType)
        })
      }
    }
  }
}
</script>


<style lang="scss">
.placements__sections {
  display: flex;
  flex-wrap: wrap;
}

.placements__sections-item {
  flex: 4 1 50%;
  margin-right: 30px;
  margin-bottom: 20px;
}

.placements-autodisable {
  max-height: 174px;
  margin-bottom: 20px;
}

</style>
